<template>
    <div id="messages" class="at-userlist_tab">
        <div v-if="groupChatEnable" class="at-userchat_tab">
          <a href="javascript:void(0);" :class="{'at-tabactive': selectedTab == 'private'}" @click.prevent="selectedTab = 'private' ">
            <i class="guppy-user"></i> 
            {{TRANS.private_txt_heading}}
            <em class="at-userchat_tab-noti" v-if="privateChatCount">{{privateChatCount > 99 ? '+99' : privateChatCount}}</em>
          </a>
          <a  href="javascript:void(0);" :class="{'at-tabactive': selectedTab == 'group'}" @click.prevent="selectedTab = 'group' " >
            <i class="guppy-users"></i> 
            {{TRANS.group_txt_heading}} 
            <em class="at-userchat_tab-noti" v-if="groupChatCount">{{groupChatCount > 99 ? '+99' : groupChatCount}}</em>
          </a>
        </div>
        <template v-if="selectedTab == 'private'">
            <private-conversation />
        </template>
        <template v-else>
            <group-conversation />
        </template>
    </div>
</template>

<script>
import GuppyChatPrivateList from "./GuppyChatPrivateList";
import GuppyChatGroupList from "./GuppyChatGroupList";
import { GUPPYCHAT_SETTINGS } from "../../../resources/constants";
import { mapState } from 'vuex';
export default {
    name: "GuppyChatConversationList",
    components:{
        PrivateConversation : GuppyChatPrivateList,
        GroupConversation : GuppyChatGroupList,
    },
    data(){
        return {
            selectedTab : 'private',
            groupChatEnable			: GUPPYCHAT_SETTINGS.groupChatEnable,
        }
    },
    computed:mapState({
      groupChatCount    :  state => state.groupChatCount,
      privateChatCount  :  state => state.privateChatCount,
    }),
};
</script>

<style>
.at-sidebarhead_search {
  width: 100%;
  position: relative;
  padding: 20px;
  background: #ffffff;
  align-self: flex-start;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
}
.at-sidebarhead_search h3 {
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 10px;
}
.at-sidebarhead_search h3 a {
  color: #3C57E5;
  display: inline-block;
  margin-left: auto;
  font-size: 14px;
  line-height: 22px;
}
.at-sidebarhead_search .at-form-group {
  padding: 0;
  display: flex;
  align-items: center;
  position: relative;
}
.at-sidebarhead_search .at-form-group i {
  position: absolute;
  left: 18px;
  font-size: 18px;
  color: var(--terguppycolor);
}
.at-chat .at-sidebarhead_search .at-form-group input {
  font-size: 14px;
  padding-left: 45px;
  width: 100%;
  height: 40px;
  outline: none;
  border-radius: 3px;
}
</style>